import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid my-10 px-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md co-sm-12" }
const _hoisted_4 = { class: "card border border-primary" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-text" }
const _hoisted_8 = {
  for: "name",
  class: "control-label"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  for: "mail",
  class: "control-label"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "d-flex justify-content-between px-3" }
const _hoisted_14 = { class: "col-md co-sm-12" }
const _hoisted_15 = { class: "card border border-success" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "card-title" }
const _hoisted_18 = { class: "card-text" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "control-label" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "control-label" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "control-label" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "d-flex justify-content-end px-3" }

import { onMounted, ref } from "vue";
import { Users } from "../../../server/dto/generated/Users";
import ListHeader from "../../components/header/ListHeader.vue";
import { DialogHandler } from "../../components/dialog/DialogHandler";
import DialogsContainer from "../../components/dialog/DialogsContainer.vue";
import { UsersService } from "../../biz/remote/UsersService";
import { SessionUser } from "../../utils/SessionUser";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { translation } from "../../lang/Translation";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditUserPage',
  setup(__props) {

const t = translation;
/**
 * 動的ラベル
 */
const editUserNameTitle = t.to("氏名", "user_edit_name");
const userEditTitle = t.to("ユーザ情報編集", "user_edit_title");
const userEditMailTitle = t.to("メールアドレス", "email");
const userEditUpdateTitle = t.to("更新", "user_edit_update");
const userEditExitTitle = t.to("退会", "user_edit_exit");
const userEditChangePassTitle = t.to("パスワード変更", "change_pass");
const userEditCurrentTitle = t.to("現在のパスワードを入力してください", "current_pass");
const userEditNewPassTitle = t.to("新しいパスワード", "new_pass");
const userEditNewPassLabel = t.to("新しいパスワードを入力してください", "new_pass_label");
const userEditConfirmPassLabel = t.to(
  "確認のため新しいをもう一度入力してください",
  "confirm_pass_label"
);
const userEditConfirmPassTitle = t.to("確認パスワード", "confirm_pass");

/**
 * プロパティ
 */
const planName = ""; // getTypedSession().getPlanName();
const user = ref(new Users());

onMounted(() => {
  const biz = new UsersService();
  biz.getUser(SessionUser.instance.userId).then((response) => {
    user.value = response.data;
  });
});

/**
 * パスワード変更
 */
const currentPassword = ref("");
const confirmPassword = ref("");
const inputPassword = ref("");
const passwordUpdate = async () => {
  const biz = new UsersService();
  const response = await biz.changePassword(
    SessionUser.instance.userId,
    inputPassword.value,
    currentPassword.value
  );
  if (response.hasError) {
    MessageDialog.error(response.errorDescription);
  } else {
    MessageDialog.info(`パスワードを変更しました`);
    currentPassword.value = "";
    confirmPassword.value = "";
    inputPassword.value = "";
  }
};

/**
 * ユーザー退会ダイアログを開く
 */
const clickDelUser = () => {
  DialogHandler.showDelUserDialog();
};

/**
 * ユーザー編集
 */
const updateDB = async () => {
  const biz = new UsersService();
  const response = await biz.userEdit(
    SessionUser.instance.userId,
    user.value.name,
    user.value.mail
  );
  if (response.hasError) {
    MessageDialog.error(response.errorDescription);
  } else {
    MessageDialog.info(`ユーザー情報を更新しました`);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BR = _resolveComponent("BR")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ListHeader, { class: "sticky-top px-5 pb-1 mb-4" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(userEditTitle)), 1),
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(" id:(" + _toDisplayString(user.value.user_id) + ")", 1),
                _createVNode(_component_BR),
                _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(editUserNameTitle)), 1),
                _withDirectives(_createElementVNode("input", {
                  ref: "name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.name) = $event)),
                  name: "name",
                  type: "text",
                  class: "form-control",
                  placeholder: _unref(editUserNameTitle)
                }, null, 8, _hoisted_9), [
                  [_vModelText, user.value.name]
                ]),
                _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(userEditMailTitle)), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "mail",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.mail) = $event)),
                  type: "email",
                  class: "form-control",
                  placeholder: "Email"
                }, null, 512), [
                  [_vModelText, user.value.mail]
                ]),
                _hoisted_11,
                _hoisted_12
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: clickDelUser
              }, _toDisplayString(_unref(userEditExitTitle)), 1),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: updateDB
              }, _toDisplayString(_unref(userEditUpdateTitle)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h4", _hoisted_17, _toDisplayString(_unref(userEditChangePassTitle)), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(userEditCurrentTitle)), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentPassword).value = $event)),
                      type: "password",
                      class: "form-control",
                      placeholder: _unref(userEditCurrentTitle),
                      required: ""
                    }, null, 8, _hoisted_22), [
                      [_vModelText, currentPassword.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(userEditNewPassLabel)), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputPassword).value = $event)),
                      type: "password",
                      class: "form-control",
                      placeholder: _unref(userEditNewPassTitle),
                      required: ""
                    }, null, 8, _hoisted_26), [
                      [_vModelText, inputPassword.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(userEditConfirmPassLabel)), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPassword).value = $event)),
                      type: "password",
                      class: "form-control",
                      placeholder: _unref(userEditConfirmPassTitle),
                      required: ""
                    }, null, 8, _hoisted_30), [
                      [_vModelText, confirmPassword.value]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: passwordUpdate
              }, _toDisplayString(_unref(userEditChangePassTitle)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(DialogsContainer)
  ], 64))
}
}

})